export default __webpack_public_path__ + "static/media/four_of_swords.2ebfc3cc.png";